import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-mui';
import TagManager from 'react-gtm-module';
import TagManagerInternal from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-5BLVCB'
}
const tagManagerInternalArgs = {
  gtmId: 'GTM-MZ7239H'
}

switch(window.location.host){
  case 'customers.bscdev.com.au':
    localStorage.setItem('server', 'https://customerapi.bscdev.com.au/');
    break;
  case 'customers.bankstownsports.com':
    localStorage.setItem('server', 'https://customerapi.bankstownsports.com/');
    TagManager.initialize(tagManagerArgs);
    TagManagerInternal.initialize(tagManagerInternalArgs);
    break;
  case 'customers.staging.bankstownsports.com':
    localStorage.setItem('server', 'https://customerapi.staging.bankstownsports.com/');
    break;
  case 'customers.develop.bankstownsports.com':
    localStorage.setItem('server', 'https://customerapi.develop.bankstownsports.com/')
    break;
  default:
    localStorage.setItem('server', 'http://127.0.0.1:8002/');
    break;
}

const options = {
  position: positions.MIDDLE,
  transition: transitions.FADE
};
//
// TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <AlertProvider template={AlertTemplate} {...options}>
    <BrowserRouter basename=""><App /></BrowserRouter>
  </AlertProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
